export default "icons-building"